import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2 } from "lucide-react";
import { ActivitiesDialog as FoodContent } from "@/components/activities/ActivitiesDialog";
import { trackTripCardAction } from "@/utils/analytics";
interface FoodDialogProps {
  showFood: boolean;
  setShowFood: (show: boolean) => void;
  foodData: any;
  destinationName: string;
  tripId: string;
}
export function FoodDialog({
  showFood,
  setShowFood,
  foodData,
  destinationName,
  tripId
}: FoodDialogProps) {
  const isFoodLoading = showFood && !foodData;
  return <Dialog open={showFood} onOpenChange={open => {
    if (!open) {
      trackTripCardAction("food", tripId, destinationName);
    }
    setShowFood(open);
  }}>
      <DialogContent className="min-h-screen w-full sm:max-w-[90vw] p-0 rounded-none my-[35px]">
        <div className="sticky top-0 z-50 bg-background border-b p-4 flex items-center gap-2">
          <Button variant="ghost" onClick={() => setShowFood(false)} size="icon" className="h-8 w-8">
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h2 className="text-base sm:text-lg md:text-xl font-semibold truncate flex-1">
            Food & Beverage in {destinationName}
          </h2>
        </div>
        
        {/* TheFork logo banner */}
        <div className="w-full py-3 px-4 flex items-center justify-center border-b bg-[#009688]">
          <div className="flex items-center gap-2">
            <img src="/lovable-uploads/7c010697-7388-47f3-b9a2-d7ae5eb41f3e.png" alt="TheFork logo" className="h-8 sm:h-10" />
            
          </div>
        </div>
        
        <div className="overflow-y-auto h-[calc(100vh-120px)] p-6">
          {isFoodLoading ? <div className="w-full flex flex-col items-center justify-center p-12">
              <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
              <p className="text-muted-foreground">Loading restaurants for {destinationName}...</p>
            </div> : <FoodContent recommendedActivities={foodData || []} destinationName={destinationName} tripId={tripId} type="food" />}
        </div>
      </DialogContent>
    </Dialog>;
}